"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "de": {
        "translation": {
            "left_navigation": {
                "loading": "Wird geladen",
                "hidden_target": "Ihre Auswahl kann aufgrund des/der angewendeten Filter nicht angezeigt werden. Entfernen Sie den oder die entsprechenden Filter, um das Element anzuzeigen.",
                "sidenav_open": "Navigation öffnen",
                "sidenav_close": "Navigation schließen",
                "expand": "Erweitern",
                "collapse": "Reduzieren",
                "small_search": "Geben Sie für die Suche wenigstens 2 Zeichen ein.",
                "no_search_results": "Keine Suchergebnisse gefunden.",
                "filter_search": "Filtern...",
                "collection_archive": "Sammlungsarchiv",
                "activities": {
                    "title": "Aktivität",
                    "details": "Einzelheiten",
                    "reset": "Zurücksetzen",
                    "load_more": "Mehr laden",
                    "no_results": "Es gibt keine Aktivitäten für den angegebenen Filter.",
                    "no_more_results": "Sie haben das Ende der Aktivitäten für den angegebenen Filter erreicht.",
                    "actions": {
                        "created": "Angelegt",
                        "deleted": "Gelöscht",
                        "updated": "Aktualisiert"
                    }
                },
                "settings": {
                    "title": "Einstellungen"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=de.js.map